import Index from './index'
import Listar from './Listar'
import Detalhes from './Detalhes'
import Novo from './Novo'
import Editar from './Editar'

const route = {
  path: '/aplicativos',
  name: 'aplicativos',
  component: Index,
  children: [
    { path: 'listar', name: 'aplicativos-listar', component: Listar },
    { path: 'novo', name: 'aplicativos-novo', component: Novo },
    { path: ':id', name: 'aplicativos-detalhes', component: Detalhes, props: true },
    { path: ':id/e', name: 'aplicativos-editar', component: Editar, props: true }
  ],
  meta: { requiresAuth: true }
}

export default route



// WEBPACK FOOTER //
// ./src/pages/aplicativos/routes.js